import { Base } from '@/models/base.model.js';
import { Company } from '@/models/company.model.js';
import { Professional } from '@/models/professional.model.js';
import { Lunch } from '@/models/lunch.model.js';
import { $ERROR, $Error } from '@utils/error';
import moment from 'moment';

const BOOKING_TYPES = Object.freeze({
	PROFESSIONAL: 'professional',
	COMPANY: 'company',
});

const BOOKING_STATUS = Object.freeze({
	CONFIRMED: 'confirmed',
	CANCELLED: 'cancelled',
});

const REQUEST_TYPE = Object.freeze({
	AVAILABILITY: 'availabiliity',
	PUBLIC_OFFER: 'public_offer',
});

const DATE_FORMAT = 'YYYY-MM-DD';

export class Booking extends Base {
	constructor(obj) {
		super(obj);
		if (!obj) return;

		this.accountid = obj.accountid;
		this.booking_request_ref = obj.booking_request_ref;
		this.end_date = obj.end_date;
		this.booking_request_type = obj.booking_request_type;
		this.status = obj.status;
		this.bookedBy = obj.bookedBy;
		this.cancelledBy = obj.cancelledBy;
		this.createdAt = obj.createdAt;
		this.start_time = obj.start_time;
		this.end_time = obj.end_time;
		this.start_date = obj.start_date;
		this.booking_dates = obj.booking_dates;
		this.booking_dates_times = obj.booking_dates_times;
		this.notes = obj.notes;
		this.unique_booking_code = obj.unique_booking_code;
		this.rates = obj.rates;
		this.company = new Company(obj.company);
		this.professional = new Professional(obj.professional);
		this.skills = obj.skills;
		this.lunch = new Lunch(obj.lunch);
		this.request_dates = Array.isArray(obj.request_dates) ? obj.request_dates.map(x => new RequestDate(x)) : [];
	}

	static get BOOKING_TYPES() {
		return BOOKING_TYPES;
	}

	static get REQUEST_TYPE() {
		return REQUEST_TYPE;
	}

	static get STATUS() {
		return BOOKING_STATUS;
	}

	static get DATE_FORMAT() {
		return DATE_FORMAT;
	}

	static sortByDate(bookings) {
		if (!Array.isArray(bookings)) throw $Error($ERROR.ERR_TYPE);
		bookings.sort((a, b) => new moment(b.start_date) - new moment(a.start_date));
	}
}

class RequestDate extends Base {
	constructor(obj) {
		super(obj);
		if (!obj) return;

		this.date = obj.date;
		this.start_time = obj.start_time;
		this.end_time = obj.end_time;
	}
}

export default Booking;
